import { render, staticRenderFns } from "./studentExamLayout.vue?vue&type=template&id=35a38194&scoped=true&"
import script from "./studentExamLayout.vue?vue&type=script&lang=js&"
export * from "./studentExamLayout.vue?vue&type=script&lang=js&"
import style0 from "./studentExamLayout.vue?vue&type=style&index=0&id=35a38194&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a38194",
  null
  
)

export default component.exports